import React from 'react';
import  {IndexLink,Link,withRouter} from 'react-router';
import axios from 'axios';
import ReactGA from 'react-ga';
import {connect} from 'react-redux';
import * as commonApi from "../../api/common-api";
import ChallengeExperientialItem from "../commons/challenge-experiential/item";
import ChallengeSubmit from "../commons/challenge-experiential/challenge-submit";

var Modal = require('react-modal');
var querystring = require('querystring');

const customStyles = {
	overlay: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.3)',
		zIndex: '999',
		overflow: 'auto'
	},
	content: {
		top: '15%',
		left: '50%',
		padding: '0',
		maxWidth: '700px',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		marginBottom: '2%',
		transform: 'translate(-50%, -15%)',
		zIndex: '999',
		maxHeight: '97vh',
		overflowX: 'hidden'
	}
};

class ExperientialChallengeDetailPage extends React.Component{
	constructor(props) {
		super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        this.state = {
			joined: 0,
			rst: [],
			skillArr: [],
			studentItem: [],
			tasks:[]
		}
		this.closeModalChallenge = this.closeModalChallenge.bind(this)
		this.handleUpdChallenge = this.handleUpdChallenge.bind(this)
	}

	componentWillMount = () => {
		this.getProject()
	}

	componentDidMount = () => {}

	componentWillUnmount = () => {}

	componentWillReceiveProps = (nextProps) => {}

	getProject = () => {
		var url = "/code/api_projects.php?api=getProjectDetail";
		var data = new FormData();
		data.append("jk", this.props.params.jk);
		axios.post(url, data)
			.then(response => {
				this.setState({rst: response.data.data, tasks: response.data.data.tasks, joined: response.data.data.isJoined}, () => {
					this.renderSkills()
					this.renderStudents()
				});
			}).catch(error => {
		});
	}

	renderSkills = () => {
		let skills = this.state.rst.skill;
		let skillArr = []

		for (var i = 0; i < skills.length; i++) {
			var label = skills[i]['lable'];
			skillArr.push(
				<li key={"skill-"+i} className="profile-skills__skill">
					<button className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view">
						<span className="artdeco-pill__text">#{label}</span>
					</button>
				</li>
			);
		}

		this.setState({skillArr: skillArr})
	}

	// handleClickJoin = () => {
	// 	var url = "/code/api_experiences.php?api=pushedJoinExperienceProject";
	// 	var data = new FormData();
	// 	data.append("id_project", this.props.params.jk);
	// 	axios.post(url, data)
	// 		.then(response => {
	// 			if (response.data.status == 1) {
	// 				this.setState({joined: 1, tasks: response.data.tasks}, () => {
	// 					this.renderStudents()
	// 				})
	// 			}
	// 			else {
	// 				commonApi.showAlert("Please try again.")
	// 			}
	// 			return response;
	// 		}).catch(error => {
	// 		this.setState({loading: false});
	// 	});
	// }

	renderStudents = () => {
		let studentItem = []
		let tasks = this.state.tasks
		studentItem.push(
			<ChallengeExperientialItem key={"task-"+this.props.params.jk} tasks={tasks} id_project={this.props.params.jk} company_name={this.state.rst.name_company}/>
		)
		this.setState({studentItem: studentItem})
	}

	handleSaveClick = () => {
		let url = '/code/api_projects.php?api=postSaveProject';
		var params = Object.assign({},
			{
				id: this.props.params.jk,
				team: this.state.rst.employer,
			}
		)
		axios.post(url, querystring.stringify(params))
			.then(response => {
				var rst_response = response.data;
				var rst = this.state.rst
				if (parseInt(rst_response.status) === 1) {
					rst['saved'] = rst_response.data
					rst['isSaved'] = rst_response.isSaved
					this.setState(Object.assign({}, rst));
					this.setState({rst: rst})
				}
				else {
					commonApi.showAlert(rst_response.message);
				}
			});
	}

	handleSavedClick = () => {
		let url = '/code/api_projects.php?api=postSavedProject';
		var params = Object.assign({},
			{
				id: this.props.params.jk,
				team: this.state.rst.employer,
			}
		)
		axios.post(url, querystring.stringify(params))
			.then(response => {
				var rst_response = response.data;
				var rst = this.state.rst
				if (parseInt(rst_response.status) === 1) {
					rst['saved'] = rst_response.data
					rst['isSaved'] = rst_response.isSaved
					this.setState(Object.assign({}, rst));
					this.setState({rst: rst})
				}
				else {
					commonApi.showAlert(rst_response.message);
				}
			});
	}

	handleClick = (act) => {
		this.props.router.push(act);
	}

	// popover challenge
	handleChallengeClick = () => {
		this.setState({showPopoverChallenge: true});
	}

	closeModalChallenge = () => {
		this.setState({showPopoverChallenge: false});
	}

	handleUpdChallenge = (tasks) => {
		this.setState({showPopoverChallenge: false, joined: 1, tasks: tasks}, () => {
			this.renderStudents()
		});
	}

	render() {
		if (this.props.user[0] === undefined || parseInt(this.state.rst.length) === 0) {
			return (
				<div className="app_page_wrapper">

				</div>
			);
		}
		let company = this.state.rst
		let item = this.state.rst
		let employer = company.employerProfile

		let f_char = company.name_company.substring(0, 1).toUpperCase()
		let avatar =  company.avata ? company.avata :  f_char

		let user_avatar = employer.avatar;
		let user_name = employer.full_name;

		if (this.state.joined) {
			return (
				<div id="student-challenge-detail" className="no-marging-top init-body--with-nav-bar">
					<div className="container-full root-linkedin" id="root-linkedin">
						<div id="challenge-educator" className="self-focused ember-view">
							<div
								className="scaffold-layout scaffold-layout--breakpoint-none scaffold-layout--sidebar-main-aside scaffold-layout--static">
								<div
									className="scaffold-layout__inner scaffold-layout-container scaffold-layout-container--static">
									<div
										className="scaffold-layout__row scaffold-layout__content scaffold-layout__content--main">
										<main id="main" className="scaffold-layout__main">
											<div id="ember1035"
												 className="ember-view box-item clearfix container-with-shadow">
												<div className="relative ember-view">
													<section id="ember3482"
															 className="pv-profile-section pv-about-section ember-view">
														<div className="pv-profile-section__card-header">
															<div className="t-14 t-bold t-black mb1 headding-3 pd30">
																{this.state.rst.title}
															</div>
															<hr className="flex-grow-1 mr2 mvA mt0"/>
														</div>
														<div className="jobs-apply-button--top-card">
															<button
																className="jobs-applied-button artdeco-button--icon-right artdeco-button--3 ember-view">
																<span className="artdeco-button__text">
																	 Submitted
																</span>
															</button>
														</div>
														<div className="top-challenge">
															<ul className="artdeco-list artdeco-list--border artdeco-list--grid t-12 t-black--light postedby-block">
																<li className="artdeco-list__item jobs-details-job-summary__section">
																	<div
																		className="app-aware-link feed-shared-actor__container-link relative display-flex flex-grow-1">
																		<div
																			className="feed-shared-actor__image relative">
																		<span className="js-feed-shared-actor__avatar">
																			<div
																				className="feed-shared-actor__avatar ivm-image-view-model ember-view">
																				<div
																					className="display-flex ivm-view-attr__img-wrapper ivm-view-attr__img-wrapper--use-img-tag ember-view">
																					<img width="48"
																						 src={avatar}
																						 height="48" alt="Study Group"
																						 className="img_circle_l ivm-view-attr__img--centered EntityPhoto-square-3 feed-shared-actor__avatar-image lazy-image ember-view"/>
																				</div>
																			</div>
																		</span>
																		</div>
																		<div
																			className="feed-shared-actor__meta relative jobs-box__html-content">
																			<span
																				className="feed-shared-actor__description t-16 t-16--open t-bold t-black">{item.name_company}</span>
																			<span className="feed-shared-actor__title">
																			<span
																				className="feed-shared-actor__name t-15 t-normal t-black">
																				<span
																					className="title contract-text">{item.city_company}</span>
																			</span>
																		</span>
																		</div>
																	</div>
																</li>
																<li className="artdeco-list__item jobs-details-job-summary__section">
																	<div
																		className="app-aware-link feed-shared-actor__container-link relative display-flex flex-grow-1">
																		<div
																			className="feed-shared-actor__image relative">
																		<span className="js-feed-shared-actor__avatar">
																			<div
																				className="feed-shared-actor__avatar ivm-image-view-model ember-view">
																				<div
																					className="display-flex ivm-view-attr__img-wrapper ivm-view-attr__img-wrapper--use-img-tag ember-view">
																					<img className="img_circle_l"
																						 src={user_avatar}
																						 alt="Profile image"/>
																				</div>
																			</div>
																		</span>
																		</div>
																		<div
																			className="feed-shared-actor__meta relative jobs-box__html-content">
																			<span
																				className="feed-shared-actor__description t-13 t-bold t-black">{user_name}</span>
																			<span className="feed-shared-actor__title">
																			<span
																				className="feed-shared-actor__name t-15 t-bold t-black">
																				<span
																					className="title contract-text">Professor</span>
																			</span>
																		</span>
																		</div>
																	</div>
																</li>
															</ul>
														</div>
														{this.state.studentItem}
													</section>
												</div>
											</div>
										</main>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		else {
			let link = "https://versity.co/post-feed/"+this.props.params.jk;
			let estimate = this.state.rst.estimate ? this.state.rst.estimate + " hours" : ""
			if (this.state.rst.estimate && parseInt(this.state.rst.estimate) === 1) {
				estimate = this.state.rst.estimate ? this.state.rst.estimate + " hour" : ""
			}
			let weekly = this.state.rst.weekly ? this.state.rst.weekly + " weeks" : ""
			let hours = this.state.rst.hours ? this.state.rst.hours + " hours per week" : ""
			let cost = parseInt(this.state.rst.to_pay) !== 2 ? this.state.rst.cost + " " : this.state.rst.cost + " per week"
			let ago = this.state.rst.ago
			let reward = this.state.rst.reward
			let allotted = this.state.rst.allotted
			let expires = this.state.rst.expires
			let master = this.state.rst.master
			let cost_extent = this.state.rst.cost_extent
			let apprx = this.state.rst.apprx
			let project_type = this.state.rst.project_type
			let types = parseInt(this.state.rst.to_pay) !== 2 ? "Onetime Project" : "Ongoing Project"

			//View Post
			let company = this.state.rst
			let f_char = company.name_company.substring(0, 1).toUpperCase()
			let avatar =  company.avata ? company.avata :  f_char
			let imgUrl = company.banner ? company.banner : '/static/img/appimg/default-banner.png';

			// params for popover
			let item = this.state.rst
			let params = {
				name_company: item.name_company,
				jk: this.props.params.jk,
				title: item.title,
				employer: item.employer,
			}

			return (
				<div id="content" className="no-marging-top init-body--with-nav-bar">
					<div className="container root-linkedin" id="root-linkedin">
						<div className="scaffold-layout__row scaffold-layout__content scaffold-layout__content--main">
							<main id="main" className="scaffold-layout__main">
								<div>
									<img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
										 className="hidden" data-elementtiming="true" alt="" role="none"/>
									<section id="ember3348" className="artdeco-card ember-view pv-top-card">
										<div className="live-video-hero-image" style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
											<div tabIndex="0" aria-label="Profile background" className="profile-background-image">
												<div className="profile-background-image__image-container">
													<img
														className="profile-background-image__image full-width full-height"
														id="profile-background-image-target-image"
														alt="Background Image"
														src={imgUrl}
													/>
												</div>
											</div>
										</div>

										<div className="ph5 pb5">
											<div className="display-flex pv-top-card--reflow">
												<div className="pv-top-card--photo text-align-left">
													<div className="pv-top-card__photo-wrapper ml0">
														<div className="presence-entity presence-entity--size-9 pv-top-card__image">
															{parseInt(avatar.length) === 1 ?
																<span>{f_char}</span>
																:
																<img title="Avatar"
																	 src={avatar}
																	 className="presence-entity__image  pv-top-card__photo no-radius  lazy-image ghost-person ember-view"/>
															}
														</div>
													</div>
												</div>
											</div>

											<div className="display-flex mt2 pv-top-card--reflow">
												<div className="flex-1 mr5 pv-top-card__list-container">
													<ul onClick={this.handleClick.bind(this, 'career-launcher')} className="pv-top-card--list inline-flex align-items-center">
														<li className="inline t-24 t-black t-normal break-words">
															<li-icon aria-hidden="true" type="chevron-left-icon"
																	 class="artdeco-button__icon" size="small">
																<svg xmlns="http://www.w3.org/2000/svg"
																	 viewBox="0 0 16 16" data-supported-dps="16x16"
																	 fill="currentColor" width="16" height="16"
																	 focusable="false">
																	<path d="M7 8l4 5.9L9.5 15 5.3 8.8a1.22 1.22 0 010-1.6L9.5 1 11 2.1z"></path>
																</svg>
															</li-icon>
															Projects
														</li>
													</ul>
													<h2 className="mt1 t-18 t-black t-normal break-words">
														{this.state.rst.title}
													</h2>
												</div>
												<div>
													<ul className="pv-top-card--experience-list align-items-flex-end">
														<li>&nbsp;</li>
														<li>
															{this.state.rst.isSaved ?
																<div className="btn btn-default" onClick={this.handleSavedClick.bind(this)}>Saved</div>
																:
																<div className="btn btn-default" onClick={this.handleSaveClick.bind(this)}>Save</div>
															}
															{this.state.rst.challenge_full ?
																<div className="btn btn-full text-info mrlr-10">Challenge Full</div>
																:
																<div className="btn btn_confirm text-info mrlr-10" onClick={this.handleChallengeClick.bind(this)}>Submit Challenge</div>
															}
														</li>
													</ul>
												</div>
											</div>
										</div>
									</section>
								</div>

								<div className="scaffold-layout--static">
									<div className="scaffold-layout__content scaffold-layout__content--main-aside">
										<main id="sub-main" className="scaffold-layout__main">
											<div id="ember3367" className="pv-oc ember-view">
												<section id="ember3482" className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
													<div className="">
														<ul className="profile-skills__skill-list profile-skills__skill-list-full experiential-step">
															<li className="profile-skills__skill">
																<img className="img_circle_r" src="/static/img/appimg/e-icon-1.png"/>
																<div className="t-13 t-bold t-black mb1">STEP 1</div>
																<div className="t-12 t-black mb1">Review and complete the <br/>challenge below</div>
															</li>
															<li className="profile-skills__skill">
																<img className="img_circle_r" src="/static/img/appimg/e-icon-2.png"/>
																<div className="t-13 t-bold t-black mb1">STEP 2</div>
																<div className="t-12 t-black mb1">Upload your response and <br/>showcase your skills</div>
															</li>
															<li className="profile-skills__skill">
																<img className="img_circle_r" src="/static/img/appimg/e-icon-3.png"/>
																<div className="t-13 t-bold t-black mb1">STEP 3</div>
																<div className="t-12 t-black mb1">Get hired based on your <br/>qualifications</div>
															</li>
														</ul>
													</div>
												</section>

												<section id="ember3482" className="pv-profile-section pv-about-section artdeco-card p5 mt4 ember-view">
													<div className="pv-profile-section__card-header">
														<h4 className="pv-profile-section__card-heading">
															Role Overview
														</h4>
													</div>
													<p id="ember3483" className="pv-about__summary-text mt4 t-14 ember-view">
														{this.state.rst.descript}
													</p>
													<div className="mt5">
														{project_type != 'challenge' ?
														<ul className="profile-skills__skill-list profile-skills__skill-list-full">
															<li className="profile-skills__skill">
																<div className="t-13 t-bold t-black mb1">Compensation</div>
																<button role="checkbox" aria-checked="false"
																		aria-label="Apache Kafka" id="ember1202"
																		className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																		type="button"><span
																	className="artdeco-pill__text">{cost_extent}</span>
																</button>
															</li>
															<li className="profile-skills__skill">
																<div className="t-13 t-bold t-black mb1">Duration</div>
																<button role="checkbox" aria-checked="false"
																		aria-label="Require.js" id="ember1203"
																		className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																		type="button"><span
																	className="artdeco-pill__text">&lt; 4 weeks</span>
																</button>
															</li>
															<li className="profile-skills__skill">
																<div className="t-13 t-bold t-black mb1">Time commitment</div>
																<button role="checkbox" aria-checked="false"
																		aria-label="Require.js" id="ember1203"
																		className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																		type="button"><span
																	className="artdeco-pill__text">{apprx}</span>
																</button>
															</li>
															<li className="profile-skills__skill">
																<div className="t-13 t-bold t-black mb1">Posted</div>
																<button role="checkbox" aria-checked="false"
																		aria-label="Require.js" id="ember1203"
																		className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																		type="button"><span
																	className="artdeco-pill__text">{ago}</span>
																</button>
															</li>
														</ul>
														:
														<ul className="profile-skills__skill-list profile-skills__skill-list-full challenge-step">
															<li className="profile-skills__skill">
																<div className="t-13 t-bold t-black mb1">Reward</div>
																<button role="checkbox" aria-checked="false"
																		aria-label="Require.js" id="ember1203"
																		className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																		type="button"><span
																	className="artdeco-pill__text">{reward}</span>
																</button>
															</li>
															<li className="profile-skills__skill">
																<div className="t-13 t-bold t-black mb1">Duration</div>
																<button role="checkbox" aria-checked="false"
																		aria-label="Require.js" id="ember1203"
																		className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																		type="button"><span
																	className="artdeco-pill__text">{expires}</span>
																</button>
															</li>
															<li className="profile-skills__skill">
																<div className="t-13 t-bold t-black mb1">Time Commitment</div>
																<button role="checkbox" aria-checked="false"
																		aria-label="Require.js" id="ember1203"
																		className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																		type="button"><span
																	className="artdeco-pill__text">{allotted}</span>
																</button>
															</li>
															<li className="profile-skills__skill">
																<div className="t-13 t-bold t-black mb1">Posted</div>
																<button role="checkbox" aria-checked="false"
																		aria-label="Require.js" id="ember1203"
																		className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																		type="button"><span
																	className="artdeco-pill__text">{ago}</span>
																</button>
															</li>
														</ul>
														}
													</div>
													{this.state.skillArr.length > 0 ?
														<div id="ember2761" className="ember-view pb15 mt5">
															<div className="t-13 t-bold t-black mb1">Skills and expertise</div>
															<ul className="profile-skills__skill-list">
																{this.state.skillArr}
															</ul>
														</div>
														:""}
												</section>
											</div>
										</main>
										<aside className="scaffold-layout__aside">
											<div id="ember83" className="pv-deferred-area mt4 ember-view">
												<div className="pv-deferred-area__content">
													<div className="artdeco-card">
														<section className="pt5 pb3 ph4">
															<h2 className="text-heading-medium">
																About the company
															</h2>
															<ul className="pv-profile-pymk__list">
																<li className="pv-pymk-section__member-container">
																	<div className="ember-view pv-pymk-section__member align-items-center mg0 pv-top-card__photo-wrapper photo-small">
																		{parseInt(avatar.length) === 1 ?
																			<span className="small">{f_char}</span>
																			:
																			<img title="Avatar"
																				 src={avatar}
																				 className="presence-entity__image  pv-top-card__photo no-radius  lazy-image ghost-person ember-view"/>
																		}
																	</div>
																	<div className="pv-pymk-section__member-cta mt1">
																		<div className="t-13 t-bold t-black mb1">Overview</div>
																		<p className="t-14">
																			{item.tagline}
																		</p>
																	</div>
																</li>
																<li className="pv-pymk-section__member-container">
																	<div className="feed-identity-module__widgets mv3">
																		<div id="ember1138"
																			 className="feed-identity-module__entity-list entity-list-wrapper ember-view">
																			<ul className="entity-list row mg0">
																				<li className="entity-list-items">
																					<div id="ember1142"
																						 className="entity-item ember-view">
																						<div id="ember1143"
																							 className="ember-view full-width">
																							<div id="ember1144"
																								 className="ember-view">
																								<div
																									className="display-flex align-items-baseline">
																									<div
																										className="text-align-left">
																										<div
																											className="t-12 t-black t-bold mr2">
																											<span>No. of Employee:</span>
																										</div>
																									</div>
																									<div
																										className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
																										<span>{item.emp_company}</span>
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																				</li>
																				<li className="entity-list-items">
																					<div id="ember1142"
																						 className="entity-item ember-view">
																						<div id="ember1143"
																							 className="ember-view full-width">
																							<div id="ember1144"
																								 className="ember-view">
																								<div
																									className="display-flex align-items-baseline">
																									<div
																										className="text-align-left">
																										<div
																											className="t-12 t-black t-bold mr2">
																											<span>Location:</span>
																										</div>
																									</div>
																									<div
																										className="feed-identity-widget-item__icon-stat t-12 t-black t-bold flex-1">
																										<span>{item.city_company}</span>
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																				</li>
																			</ul>
																		</div>
																	</div>
																</li>
																<li className="pv-pymk-section__member-container">
																	<button onClick={this.handleClick.bind(this, 'company/'+item.id_company)} role="checkbox" aria-checked="false"
																			aria-label="Apache Kafka" id="ember1202"
																			className="artdeco-pill--slate artdeco-pill--2 artdeco-pill--toggle ember-view"
																			type="button"><span
																		className="artdeco-pill__text">Learn More</span>
																	</button>
																</li>
															</ul>
														</section>
													</div>
												</div>
											</div>
										</aside>
									</div>
								</div>
							</main>
						</div>
					</div>

					<Modal
						isOpen={this.state.showPopoverChallenge}
						onRequestClose={this.closeModalChallenge.bind(this)}
						style={customStyles}
						shouldCloseOnOverlayClick={false}
						contentLabel="Submit Challenge to ..."
					>
						<div className="submit-and-request">
							<ChallengeSubmit params={params} handleUpdChallenge={this.handleUpdChallenge} closeModalChallenge={this.closeModalChallenge} id_project={this.props.params.jk}/>
						</div>
					</Modal>
				</div>
			);
		}
	}
}

ExperientialChallengeDetailPage.propTypes = {
	router: React.PropTypes.shape({
		push: React.PropTypes.func.isRequired
	}).isRequired
};
const mapStateToProps = function (store) {
	return {
		user: store.userState.user
	};
};

export default connect(mapStateToProps)(withRouter(ExperientialChallengeDetailPage));


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/pages/experiential-challenge-detail.js
 **/